import { useFormContext } from 'react-hook-form'

import { GEOFENCE_FIELDS } from '@/feature/observatory'

import styles from '../../GeoFenceCreateEdit.module.css'
import { getFieldError, shouldShowError } from '../../GeoFenceCreateEdit.utils'

export const TitleField = () => {
  const { register, getFieldState } = useFormContext()

  return (
    <>
      <div className={styles.createTitleEditor}>
        <input
          placeholder="Untitled"
          {...register(GEOFENCE_FIELDS.title)}
          className={[
            styles.createTitle,
            shouldShowError(getFieldState(GEOFENCE_FIELDS.title)) ? styles.error : '',
          ].join(' ')}
          data-testid="geofence-title-input"
        />
      </div>
      <div className={styles.errorLine} data-testid="geofence-title-error">
        {getFieldError(getFieldState(GEOFENCE_FIELDS.title))}
      </div>
    </>
  )
}
